import * as yup from 'yup';

const TWITTER_REGEX = /^(\w){1,15}$/;
const LINKEDIN_REGEX = /^([0-9a-z-]){3,100}$/;
const INSTAGRAM_REGEX = /^([\w.]){1,30}$/;
const URL_REGEX =
  /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;

const SocialSchema = () =>
  yup.object().shape({
    twitter: yup.string().matches(TWITTER_REGEX, 'Please enter a valid Twitter handle'),
    linkedin: yup.string().matches(LINKEDIN_REGEX, 'Please enter a valid LinkedIn handle'),
    instagram: yup.string().matches(INSTAGRAM_REGEX, 'Please enter a valid Instagram handle'),
    personalUrl: yup.string().matches(URL_REGEX, 'Please enter a valid URL'),
  });

export default SocialSchema;
